(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("3X68x", function(module, exports) {
var $2e0ba46dc31d42b6$var$anchorLinks = document.querySelectorAll('a[href^="#"]');
$2e0ba46dc31d42b6$var$anchorLinks.forEach(function(anchor) {
    anchor === null || anchor === void 0 || anchor.addEventListener("click", function(e) {
        var targetSelector = anchor.getAttribute("href");
        if (!targetSelector || targetSelector === "#") return;
        var target = document.querySelector(targetSelector);
        if (!target) return;
        e.preventDefault();
        window.scrollTo({
            top: target.offsetTop,
            behavior: "smooth"
        });
    });
});

});

})();
//# sourceMappingURL=anchor-scroll.03a71060.js.map
